// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"208":"333bd9b7","626":"25a2e93c","875":"b37fad64"}[chunkId] + ".chunk.js";
};